import * as React from 'react';
import classNames from 'classnames';

import join from 'lodash/join';

/**
 * Renders background position choice for `<BackgroundImagePosition />`.
 */
export class BackgroundImagePositionChoice extends React.PureComponent {
    render() {
        const { id, selected, onClick, value } = this.props;

        return (
            <a
                id={id}
                className={classNames(
                    'background-image-manager__area',
                    selected
                        ? 'background-image-manager__area--is-selected'
                        : `background-image-manager__area--${join(value, '-')}`,
                )}
                onClick={onClick}
            />
        );
    }
}
